/**
 * Sanitizes a PDF filename for safe upload.
 * - Normalizes and strips diacritics (á→a, ñ→n, etc.)
 * - Replaces any character outside [a-zA-Z0-9._-] with _
 * - Collapses consecutive underscores
 * - Trims leading/trailing underscores from the base name
 */
export function sanitizeFilename(name: string): string {
	const ext = /\.(pdf|zip)$/i.test(name) ? name.slice(name.lastIndexOf('.')) : '';
	const base = name.slice(0, name.length - ext.length);

	const sanitized = base
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.replace(/[^a-zA-Z0-9_-]/g, '_')
		.replace(/_+/g, '_')
		.replace(/^_+|_+$/g, '');

	return sanitized + ext;
}
